import script from "./TecnicoGestion.vue?vue&type=script&setup=true&lang=js"
export * from "./TecnicoGestion.vue?vue&type=script&setup=true&lang=js"

import "./TecnicoGestion.vue?vue&type=style&index=0&id=6e512abe&lang=css"

const __exports__ = script;

export default __exports__